import React,{useEffect,useState} from "react";
import { TextField, MenuItem, Grid, Typography,Card,CardMedia } from "@mui/material";
import apiClient from "./api/apiClient";
const typeOfAddressOptions = ["PRESENT", "PERMANENT", "PRESENT&PERMANENT", "PREVIOUS"];
const typeOfStayOptions = ["OWNED", "RENTED", "COMPANY ACCOMMODATION", "PG"];

const LabeledInput = ({ label, value, isSelect = false, options = [] }) => (
  <TextField
    label={label}
    value={value}
    fullWidth
    select={isSelect}
    margin="normal"
    disabled
  >
    {isSelect &&
      options.map((opt, idx) => (
        <MenuItem key={idx} value={opt}>
          {opt}
        </MenuItem>
      ))}
  </TextField>
);

const CheckDetailsComponent = ({ lhsDetails, rhsDetails }) => {
  const [photoUrls, setPhotoUrls] = useState([]);
  const [photoIsLoading, setPhotoIsLoading] = useState(true);
  useEffect(() => {
    const fetchPhotos = async () => {
      try {
        const { caseId, checkType, checkId } = lhsDetails; // Assuming checkType & checkId are in lhsDetails
        const response = await apiClient.get(
          `/addresscheckones/photographs/${caseId}/${checkType}/${checkId}`
        );
        console.log("Response with phtotographs is ",response);
//        const data = await response.json(); // e.g., ["url1.jpg", "url2.jpg"]
        setPhotoUrls(response.data);
      } catch (err) {
        console.error("Error fetching photos:", err);
      }finally{
        setPhotoIsLoading(false);
      }
    };

    fetchPhotos();
  }, [lhsDetails]);

  return (
    <Grid container spacing={4} padding={4}>

      {/* Case Details Section */}
      <Grid item xs={12}>
        <Typography variant="h6" color="primary" gutterBottom>
          Case Details
        </Typography>
        <Grid container spacing={2}>
          <Grid item xs={12} md={4}>
            <LabeledInput label="Case ID" value={lhsDetails.caseId} />
          </Grid>
          <Grid item xs={12} md={4}>
            <LabeledInput label="Candidate Name" value={lhsDetails.candidateName} />
          </Grid>
          <Grid item xs={12} md={4}>
            <LabeledInput label="Client Name" value={lhsDetails.clientName} />
          </Grid>
        </Grid>
      </Grid>

      {/* Personal Details Section */}
      <Grid item xs={12}>
        <Typography variant="h6" color="primary" gutterBottom>
          Personal Details
        </Typography>
        <Grid container spacing={2}>
          <Grid item xs={12} md={6}>
            <LabeledInput label="Father's Name" value={lhsDetails.fatherName} />
          </Grid>
          <Grid item xs={12} md={6}>
            <LabeledInput label="Date of Birth" value={lhsDetails.dateOfBirth} />
          </Grid>
        </Grid>
      </Grid>

      {/* LHS Address Details */}
      <Grid item xs={12} md={6}>
        <Typography variant="h6" color="primary" gutterBottom>
          LHS Address Details
        </Typography>
        <LabeledInput label="Address" value={lhsDetails.address} />
        <LabeledInput label="Landmark" value={lhsDetails.landmark} />
        <LabeledInput label="PIN" value={lhsDetails.pin} />
        <LabeledInput label="City" value={lhsDetails.city} />
        <LabeledInput label="State" value={lhsDetails.state} />
        <LabeledInput label="Type of Address" value={lhsDetails.typeOfAddress} isSelect options={typeOfAddressOptions} />
        <LabeledInput label="Type of Stay" value={lhsDetails.typeOfStay} isSelect options={typeOfStayOptions} />
        <LabeledInput label="Period of Stay From" value={lhsDetails.periodOfStayFrom} />
        <LabeledInput label="Period of Stay To" value={lhsDetails.periodOfStayTo} />
      </Grid>

      {/* RHS Address Details */}
      <Grid item xs={12} md={6}>
        <Typography variant="h6" color="secondary" gutterBottom>
          RHS Address Details
        </Typography>
        <LabeledInput label="Landmark" value={rhsDetails.landmarkRhs} />
        <LabeledInput label="Type of Address" value={rhsDetails.typeOfAddressRhs} isSelect options={typeOfAddressOptions} />
        <LabeledInput label="Type of Stay" value={rhsDetails.typeOfStayRhs} isSelect options={typeOfStayOptions} />
        <LabeledInput label="Period of Stay From" value={rhsDetails.periodOfStayFromRhs} />
        <LabeledInput label="Period of Stay To" value={rhsDetails.periodOfStayToRhs} />
        <LabeledInput label="Geo Tag" value={rhsDetails.geotag} />
        <LabeledInput label="Geo Tag Timestamp" value={rhsDetails.geotagTimestamp} />
        <LabeledInput label="Respondent One Name" value={rhsDetails.referenceOneName} />
        <LabeledInput label="Respondent One Address" value={rhsDetails.referenceOneAddress} />
        <LabeledInput label="Respondent One Contact Number" value={rhsDetails.referenceOneContactNumber} />
        <LabeledInput label="Respondent One Relationship" value={rhsDetails.referenceOneRelationship} />
        <LabeledInput label="Respondent Two Name" value={rhsDetails.referenceTwoName} />
        <LabeledInput label="Respondent Two Address" value={rhsDetails.referenceTwoAddress} />
        <LabeledInput label="Respondent Two Contact Number" value={rhsDetails.referenceTwoContactNumber} />
        <LabeledInput label="Respondent Two Relationship" value={rhsDetails.referenceTwoRelationship} />
        <LabeledInput label="Status" value={rhsDetails.status} />
        <LabeledInput label="Color Code" value={rhsDetails.colorCode} />
        <LabeledInput label="Field Executive Insufficiency Comments" value={rhsDetails.insufficiencyComment} />
        <LabeledInput label="Field Executive Comments" value={rhsDetails.fieldComments} />
      </Grid>
      <Grid item xs={12}>
        <Typography variant="h6" color="primary" gutterBottom>
          Photographs
        </Typography>
        <Grid container spacing={2}>
          {photoUrls.length > 0 ? (
            photoUrls.map((url, idx) => (
              <Grid item xs={12} sm={6} md={3} key={idx}>
                <Card>
                  <CardMedia
                    component="img"
                    height="180"
                    image={`data:image/jpeg;base64,${url}`}
                    alt={`Photo ${idx + 1}`}
                  />
                </Card>
              </Grid>
            ))
          ) : (
            <Typography variant="body1" sx={{ marginLeft: 2 }}>
              No photographs available.
            </Typography>
          )}
        </Grid>
      </Grid>


    </Grid>
  );
};

export default CheckDetailsComponent;
